import {
  Component, Output, EventEmitter, Input
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { COUNTRY_LIST, SALUTATION, ADDITIONAL_ADDRESS_TYPES } from 'app/constants';
import { ContactType } from 'graphql/models/generated';
import { DropdownItem } from 'models/dropdown.model';

@Component({
  selector: 'app-objekt-basic-info-additional-address',
  templateUrl: './additional-address.component.html',
  styleUrls: ['./additional-address.component.scss']
})
export class ObjektAdditionalAddressComponent {
  dropdownData = {
    countries: COUNTRY_LIST,
    salutation: SALUTATION
  };

  isCollapsed = false;

  @Input() form!: UntypedFormGroup;

  @Input() canUpdateObjekt = true;

  @Output() addressRemoved = new EventEmitter<boolean>();

  get addressForm(): UntypedFormGroup {
    return this.form.controls.address as UntypedFormGroup;
  }

  get addressTitle(): string {
    const addressType: ContactType = this.form.controls.contactType.value;
    const address: DropdownItem<ContactType> | undefined = ADDITIONAL_ADDRESS_TYPES.find(
      (a) => a.value === addressType
    );

    return address ? address.title : '';
  }

  onAddressRemoval(): void {
    if (this.canUpdateObjekt) {
      this.addressRemoved.emit(true);
    }
  }
}
